'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('quickbooks-overview', {
      url: '/admin/list/quickbooks-overview',
      template: '<quickbooks-overview></quickbooks-overview>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/import/quickbooks-overview/quickbooks-overview.routes.js